/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../../shared/generated.types'

import { api } from '../../../utils'
export const ProgramSettingsExternalFrag = `
    fragment ProgramSettingsExternalFrag on ProgramSettingsExternal {
  patientSettings {
    overlappingInsurancePlans {
      id
      description
      planIds
      favoredPlanId
    }
  }
}
    `
export const GetProgramSettingsExternalDocument = `
    query getProgramSettingsExternal {
  getProgramSettingsExternal {
    ...ProgramSettingsExternalFrag
  }
}
    ${ProgramSettingsExternalFrag}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProgramSettingsExternal: build.query<
      Types.GetProgramSettingsExternal,
      Types.GetProgramSettingsExternalVariables | void
    >({
      query: (variables) => ({
        document: GetProgramSettingsExternalDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
